import { atom } from "jotai";

const isGoogleMapsLoadedAtom = atom(false);
isGoogleMapsLoadedAtom.debugLabel = "Is Google Maps Loaded Atom";

export default isGoogleMapsLoadedAtom;
